import React, { Component } from "react";

import axios from "axios";
import { Link } from "react-router-dom";
import { getData } from "./actions";
import { Button } from "@material-ui/core";
import { deleteDraft } from "API";
import { DRAFTS_ENDPOINT } from "../../API/endpoints/draft";
import { withRouter } from "react-router-dom";
import RELEASING_CENTERS from "types/releasingCenter";

export class DraftView extends Component {
  state = {
    initializeValue: true,

    showPage1: true,
    showPage2: false,

    showPage1Err: false,
    showPage2Err: false,

    listBudgetLineItem: [],

    projectClass: [],
    vendorLists: [],
    projectLists: [],
    itemNoLists: [],

    removal: false,
    target: null,

    requestingGrossPrice: [],
    bliObj: {},
  };
  handleChangeRequestingDepartment = () => {
    this.setState({
      requestingDepartment: true,
    });
  };
  handleChangeBudgetLineItem = (e) => {
    const value = JSON.parse(e.target.value);
    this.setState({
      accountCode: value.accountCode,
      accountName: value.accountName,
    });
    document.getElementsByName(
      "glAccount"
    ).value = `${value.accountCode}/ ${value.accountName}`;
    this.props.handleChangeProjectClassValue(e);
  };

  componentDidMount() {
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/${this.props.requestId}`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        const i = response.data.data;

        this.setState({
          initializeValue: true,
          receivingDate: i.receivingDate,
          termDays: i.termDays,
          requestType: i.requestType,
          requestor: i.requestor.firstName + " " + i.requestor.lastName,
          subProject: i.subProject,
          projectClass: i.projectClasses,
          dueDate: i.dueDate,
          creationDate: i.creationDate,
          _id: i._idDate,
          rejectionMessage: i.rejectionMessage,
          vendor: i.vendor,
        });
        axios({
          method: "GET",
          url: `${process.env.REACT_APP_API_KEY}/api/projects/${i.projectName}`,
          headers: {
            "Api-Key":
              "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
            Authorization: `Bearer ${localStorage.token}`,
          },
        })
          .then((response) => {
            this.setState({
              projectCode: response.data.data.projectCode,
            });

            axios({
              method: "GET",
              url: `${process.env.REACT_APP_API_KEY}/api/glAccountTypes/${response.data.data.projectCode}`,
              headers: {
                "Api-Key":
                  "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
                Authorization: `Bearer ${localStorage.token}`,
              },
            })
              .then((response) => {
                this.setState({
                  accountTypes: response.data.data,
                });
              })
              .catch((error) => {
                //   
              });
          })
          .catch((error) => {
              
          });

        if (i.vendor) {
          this.setState({
            vendor: i.vendor,
          });
          document.getElementById("vendorInput").value = i.vendor;
        }

        if (response.data.data.particulars) {
          this.setState({
            particulars: response.data.data.particulars,
          });
          document.getElementById("particularsInput").value = i.particulars;
        }

        if (i.department) {
          this.setState({
            requestingDepartment: i.department,
          });
          document.getElementById("departmentInput").value = i.department;
        }

        if (i.projectName) {
          this.setState({
            project: i.projectName,
          });

          document.getElementById("projectInput").value = i.projectName;
        }

        // Set net prices here, because it's not available on the database yet.

        // let accountType = [];
        // let accountName = [];
        // let quantity = [];
        // let subtotalGrossPrice = [];
        // let subtotalUnitPrice = [];
        // for (let i = 0; i < this.props.projectClass.length; i++) {
        //   accountType.push(this.props.projectClass[i].glAccount.accountType);
        //   accountName.push(this.props.projectClass[i].glAccount.accountName);
        //   quantity.push(this.props.projectClass[i].quantity);
        //   subtotalGrossPrice.push(
        //     this.props.projectClass[i].grossPrice *
        //       this.props.projectClass[i].quantity
        //   );
        //   subtotalUnitPrice.push(this.props.projectClass[i].unitPrice);
        // }

        // let totalGrossPrice = 0;
        // for (let subt = 0; subt < this.props.projectClass.length; subt++) {
        //   totalGrossPrice = totalGrossPrice + subtotalGrossPrice[subt];
        // }

        // let totalUnitPrice = 0;
        // for (let subt = 0; subt < this.props.projectClass.length; subt++) {
        //   totalUnitPrice = totalUnitPrice + subtotalUnitPrice[subt];
        // }

        // this.setState({
        //   accountType: accountType,
        //   accountName: accountName,
        //   totalGrossPrice: totalGrossPrice,
        //   quantity: quantity,
        //   totalUnitPrice: totalUnitPrice,
        // });
        for (let index = 0; index < i.projectClass.length; index++) {
          axios({
            method: "GET",
            url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/accountName/${i.projectClass[index].glAccount}`,
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              i.projectClass[index].accountName =
                response.data.data[index].accountName;

              for (let i = 0; i < i.projectClass.length; i++) {
                axios({
                  method: "GET",
                  url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/accountName/${i.projectClass[i].glAccount}`,
                  headers: {
                    "Api-Key":
                      "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
                    Authorization: `Bearer ${localStorage.token}`,
                  },
                })
                  .then((response) => {})
                  .catch((error) => {
                    //   
                  });
                document.getElementsByClassName("glNameClass")[i].value =
                  i.projectClass[i].glAccount +
                  " " +
                  i.projectClass[i].accountName;
              }
            })
            .catch((error) => {
              //   
            });
        }
      })
      .catch((error) => {
        //   
      });

    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/itemNo`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        this.setState({
          itemNoLists: response.data.data,
        });
      })
      .catch((error) => {
        //   
      });

    if (document.getElementById("poInput")) {
      document.getElementById("poInput").value = this.props.poNumber;
    }

    if (this.props.requestingDepartment !== "") {
      document.getElementById("departmentInitialValue").innerText =
        this.props.requestingDepartment;
    }
    document.getElementById("vendorInput").value = this.props.vendor;
    document.getElementById("particularsInput").value = this.props.particulars;
    document.getElementById("projectInput").value = this.props.project;

    for (let i = 0; i < this.props.projectClass.length; i++) {
      if (this.props.requestType === "PO Item") {
        if (this.props.projectClass[i].itemCode) {
          document.getElementsByName("itemCode")[i].value =
            this.props.projectClass[i].itemCode;
          document.getElementsByName("quantity")[i].value =
            this.props.projectClass[i].quantity;
        } else {
          document.getElementsByName("itemCode")[i].value = "";
        }
      }

      if (this.props.projectClass[i].vatType !== "") {
        document.getElementsByClassName("vatTypeInitialValue")[i].innerText =
          this.props.projectClass[i].vatType;
      }
    }
  }
  getSubtotalGrossPrice = (index) => {
    return (
      this.props.projectClass[index].quantity *
      this.props.projectClass[index].grossPricePerItem
    );
  };

  getSubtotalNetPrice = (index) => {
    return this.props.projectClass[index].subTotalNetPrice;
  };

  getRequestingGrossPrice = (e) => {
    let total = 0;

    for (let i = 0; i < this.props.projectClass.length; i++) {
      total += e[i].quantity * e[i].grossPricePerItem;
    }
    return total;
  };
  getRequestingAmountPrice = () => {
    let total = 0;
    for (let lineItem of this.props.projectClass) {
      total += lineItem.subTotalNetPrice;
    }
    return total.toString().slice(1);
  };
  handleShowPage2 = async (e) => {
    e.preventDefault();
    if (this.props.dueDate === "") {
      alert("Due date is required");
      return;
    }
    if (!this.validateDueDate(this.props.dueDate)) {
      alert("Due date must be greater than or equal to current date");
      return;
    }
    const data = await this.props.handleSubmitDraft(e, "fromFirstPage");
    if (data) return;
    document.getElementById("page1").style.display = "none";
    document.getElementById("nextButton").style.display = "none";
    document.getElementById("page2").style.display = "block";
    document.getElementById("formPrevBtn").style.display = "block";
    document.getElementById("totalComputation").style.display = "flex";
    document.getElementById("submitButtonDiv").style.display = "block";
  };

  handleShowPage1 = (e) => {
    e.preventDefault();
    document.getElementById("page1").style.display = "block";
    document.getElementById("nextButton").style.display = "block";
    document.getElementById("page2").style.display = "none";
    document.getElementById("formPrevBtn").style.display = "none";
    document.getElementById("totalComputation").style.display = "none";
    document.getElementById("submitButtonDiv").style.display = "none";
  };

  handleRemoveProjectClass = (e) => {
    this.props.projectClass.splice(parseInt(e.target.id), 1);
    this.setState({
      target: parseInt(e.target.name),
      removal: true,
    });
  };
  currentDate = () => {
    const dateArray = Date().split(" ");
    let month = "";
    const day = dateArray[2];
    const year = dateArray[3];
    switch (dateArray[1]) {
      case "Feb":
        month = "02";
        break;
      case "Mar":
        month = "03";
        break;
      case "Apr":
        month = "04";
        break;
      case "May":
        month = "05";
        break;
      case "Jun":
        month = "06";
        break;
      case "Jul":
        month = "07";
        break;
      case "Aug":
        month = "08";
        break;
      case "Sep":
        month = "09";
        break;
      case "Oct":
        month = "10";
        break;
      case "Nov":
        month = "11";
        break;
      case "Dec":
        month = "12";
        break;
      default:
        month = "01";
    }
    return `${year}-${month}-${day}`;
  };

  validateDueDate = (date) => {
    const currentDate = new Date();
    const givenDate = new Date(date.substring(0, 10));
    if (givenDate < currentDate) {
      if (this.currentDate() === date.substring(0, 10)) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  };

  confirmDeletion = () => {
    const r = window.confirm("Are you sure you want to delete this draft?");
    if (r == true) {
      deleteDraft(this.props.requestId);
      this.props.handleNavigateBack(this.props.requestId);
    }
  };

  render() {
    let projectClassList = [];
    for (let key in this.props.projectClass) {
      projectClassList.push(key);
    }

    let particularsEmptyChecker = "";
    if (this.props.particularsError === true) {
      particularsEmptyChecker = (
        <>
          {this.props.particulars === "" ? (
            <small style={errorChecker}>This field can't be empty</small>
          ) : null}
        </>
      );
    }

    let vendorEmptyChecker = "";
    if (this.props.vendorError === true) {
      vendorEmptyChecker = (
        <>
          {this.props.vendor === "" ? (
            <small style={errorChecker}>This field can't be empty</small>
          ) : null}
        </>
      );
    }

    let projectEmptyChecker = "";
    if (this.props.projectError === true) {
      projectEmptyChecker = (
        <>
          {this.props.project === "" ? (
            <small style={errorChecker}>This field can't be empty</small>
          ) : null}
        </>
      );
    }

    let fileEmptyChecker = "";
    if (this.props.file) {
      projectEmptyChecker = (
        <>
          {this.props.file === null ? (
            <small style={errorChecker}>Please upload A file</small>
          ) : null}
        </>
      );
    }

    if (this.state.removal === true) {
      projectClassList.splice(this.state.target, 1);

      projectClassList = this.props.projectClass;
    }

    return (
      <>
        <div className="formContent">
          <div className="formNavigationBtn">
            <div className="formNavContent">
              <div id="formPrevBtn" className="formNav1">
                <button type="button" onClick={this.handleShowPage1}>
                  <i class="fas fa-arrow-alt-circle-left"></i>
                  {/* back */}
                </button>
              </div>
            </div>
          </div>

          {/* PAGE 1 */}

          <form onSubmit={this.props.handleSubmitDraft}>
            <div className="saveAndCancelButton">
              <div className="saveAndCancelButtonContent">
                <Button
                  onClick={() => {
                    this.confirmDeletion();
                  }}
                >
                  Delete
                </Button>
                <button
                  style={styleBtn}
                  id="draftSaveBtn"
                  type="button"
                  onClick={this.props.handleDraftNonPo}
                >
                  SAVE
                </button>
              </div>
            </div>
            <div className="page1" id="page1">
              {/* due date */}
              <p className="label1">
                Receiving Date
                <span id="vendorEmptyError" className="errorChecker">
                  *
                </span>
              </p>
              <input
                type="date"
                className="input1NonPo"
                name="receivingDate"
                value={
                  this.props.receivingDate
                    ? this.props.receivingDate.substring(0, 10)
                    : this.props.receivingDate
                }
                onBlur={this.props.handleChangeRequestField}
                onChange={this.props.handleChangeRequestField}
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                placeholder="Required"
                autoComplete="off"
              />
              <p className="label1">
                Term Days
                <span id="vendorEmptyError" className="errorChecker">
                  *
                </span>
              </p>
              <input
                type="number"
                className="input1NonPo"
                name="termDays"
                min={1}
                max={1000}
                value={this.props.termDays}
                onBlur={this.props.handleChangeRequestField}
                onChange={this.props.handleChangeRequestField}
                placeholder="# of term days"
                autoComplete="off"
              />
              <p className="label1">
                Due date
                <span id="vendorEmptyError" className="errorChecker">
                  *
                </span>
              </p>
              <input
                type="date"
                className="input1NonPo"
                name="dueDate"
                id="dueDate"
                value={
                  this.props.dueDate
                    ? this.props.dueDate.substring(0, 10)
                    : this.props.dueDate
                }
                onBlur={(e) => this.props.changed(e, 0, "dueDate")}
                onChange={(e) => this.props.changed(e, 0, "dueDate")}
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                placeholder="Required"
                autoComplete="off"
              />
              {/* PO NUMBER */}
              {this.props.requestType === "PO Item" ? (
                <>
                  <p className="label1">
                    PO NUMBER
                    <span id="vendorEmptyError" className="errorChecker">
                      *
                    </span>
                  </p>
                  <input
                    type="text"
                    className="input1NonPo"
                    name="poNumber"
                    id="poInput"
                    value={this.props.poNumber}
                    onChange={(e) => this.props.changed(e, 0, "poNumber")}
                    placeholder="Required"
                    autoComplete="off"
                  />
                </>
              ) : null}
              {/* END OF PO NUMBER */}

              {/* VENDOR INPUT*/}
              <p className="label1">
                Vendor/Payee:
                <span id="vendorEmptyError" className="errorChecker">
                  *
                </span>
              </p>
              <input
                type="text"
                className="input1NonPo"
                list="vendorListOptions"
                name="vendor"
                id="vendorInput"
                value={this.props.vendor}
                onChange={this.props.handleChangeRequestField}
                placeholder="Required"
              />

              <datalist id="vendorListOptions">
                {this.props.vendorLists.map((data) => (
                  <option className="vendorListData" value={data} />
                ))}
              </datalist>

              <div>
                <small style={errorChecker}></small>
                <small></small>
              </div>
              {vendorEmptyChecker}
              {/* END OF VENDOR INPUT */}

              {/* REQUESTING DEPARTMENT INPUT*/}
              <p className="label1">
                Requesting Department:
                <span id="particularsEmptyError" className="errorChecker">
                  *
                </span>
              </p>
              <select
                type="text"
                className="input1NonPoNew"
                id="departmentInput"
                name="requestingDepartment"
                onChange={(e) => {
                  this.props.handleChangeRequestField(e);
                  this.handleChangeRequestingDepartment();
                }}
                autoComplete="off"
                placeholder="Required"
              >
                <option
                  id="departmentInitialValue"
                  value=""
                  disabled
                  selected
                  hidden
                >
                  Please Choose...
                </option>
                {this.props.userDeptList
                  .filter((list) => list.isApproved === true)
                  .map((depts) => (
                    <option value={depts.centerName}>{depts.centerName}</option>
                  ))}
              </select>
              {/* END OF REQUESTING DEPARTMENT INPUT */}

              {/* PARTICULARS INPUT*/}
              <p className="label1">
                Particulars:
                <span id="particularsEmptyError" className="errorChecker">
                  *
                </span>
              </p>
              <input
                type="text"
                className="input1NonPo"
                id="particularsInput"
                name="particulars"
                onChange={this.props.handleChangeRequestField}
                autoComplete="off"
                placeholder="Required"
              />
              {particularsEmptyChecker}
              {/* END OF PARTICULARS INPUT */}
              <input
                id="departmentInput"
                type="hidden"
                value={this.props.userDepartment}
              />

              {/* PROJECT INPUT*/}
              <p className="label1">
                Cost Center:
                <span id="projectEmptyError" className="errorChecker">
                  *
                </span>
              </p>
              <input
                type="text"
                className="input1NonPo"
                list="projectDataLists"
                id="projectInput"
                name="project"
                value={this.props.project}
                onChange={this.props.handleChangeRequestField}
                placeholder="Required"
              />
              <datalist id="projectDataLists">
                {this.props.projectLists.map((data) => (
                  <option value={data.projectName}>{data.projectCode}</option>
                ))}
              </datalist>

              {/* END OF PROJECT INPUT */}

              {/* SUPPORTING DOCUMENTS INPUT*/}

              <p className="label1">
                Change Supporting Documents:
                <span id="documentEmptyError" className="errorChecker"></span>
              </p>
              <div className="fileInputContainer">
                <div className="uploadedFile">
                  {fileEmptyChecker}
                  {this.props.file !== null ? (
                    <>
                      <h1 className="fileIcon" style={{ paddingTop: "10px" }}>
                        <i class="far fa-file-pdf"></i>
                      </h1>
                      <span>
                        {this.props.file === undefined
                          ? this.props.fileText
                            ? this.props.fileText
                            : "Please upload a file..."
                          : this.props.file.name}
                      </span>
                    </>
                  ) : this.props.fileText ? (
                    <>
                      <h1 className="fileIcon">
                        <i class="far fa-file-pdf"></i>
                      </h1>
                      <span>{this.props.fileText}</span>
                    </>
                  ) : null}
                </div>

                <label htmlFor="documentsInput" className="fileLabel">
                  {this.props.file ? "Change File" : "Change File"}
                </label>
                <input
                  style={displayNone}
                  type="file"
                  id="documentsInput"
                  name="file"
                  accept=".pdf"
                  onChange={this.props.handleChangeRequestField}
                />
              </div>
              {this.props.fileText ? (
                <div className="currentAttachPdfContainer">
                  <button
                    style={currentAttachPdf}
                    className="currentAttachPdf"
                    type="button"
                    onClick={this.props.handleDownloadPdf}
                  >
                    <i class="fas fa-file-pdf"></i> Current File Attached
                  </button>
                </div>
              ) : (
                <span></span>
              )}

              {/* END OF SUPPORTING DOCUMENTS INPUT */}
            </div>
            {/* END OF PAGE 1 */}
            {/* PAGE 2 */}
            <div className="page2" id="page2">
              {/* ===================================================================================================================== */}

              {this.props.projectClass.map((data, index) => (
                <div
                  className="projectClassContainer"
                  key={"projectClassContainer" + index}
                >
                  <div className="closeButtonContainer">
                    <h3 style={{ float: "left" }}>{parseInt(index) + 1}</h3>
                    {index === 0 ? (
                      <span></span>
                    ) : (
                      <button
                        type="button"
                        className="removeProjClassBtn"
                        onClick={(e) =>
                          this.props.handleRemoveProjectClass(e, index)
                        }
                        name={index}
                      >
                        &times;
                      </button>
                    )}
                  </div>
                  {/* GL CATEGORY INPUT */}
                  <p className="label2">
                    Budget Line Item
                    <span
                      style={errorChecker}
                      className="projectClassEmptyError"
                    >
                      *
                    </span>
                  </p>
                  <select
                    className="glNameClass"
                    name="glCategory"
                    id={index}
                    onChange={this.handleChangeBudgetLineItem}
                    onLoad={this.props.projectClass[index]["glAccount"]}
                  >
                    {this.props.projectClass[index]["glCategory"] ? (
                      <option
                        className="glCategoryInitialValue"
                        value={JSON.stringify(
                          this.props.budgetLineItemList[index]
                        )}
                        selected
                      >
                        {this.props.projectClass[index]["glCategory"]} ➡{" "}
                        {this.props.projectClass[index]["glAccount"].slice(11)}
                      </option>
                    ) : (
                      <option
                        className="glCategoryInitialValue"
                        selected
                        hidden
                      >
                        Please Choose...
                      </option>
                    )}
                    {this.props.project === "General"
                      ? this.props.accountTypes.map((item) => (
                          <option
                            value={JSON.stringify(item)}
                            style={{ fontWeight: "bold" }}
                          >
                            {item.budgetLineItem} 📜➡ {item.accountName} ➡{" "}
                            {item.projectCode}
                          </option>
                        ))
                      : this.props.accountTypes.map((item) => (
                          <option
                            value={JSON.stringify(item)}
                            style={{ fontWeight: "bold" }}
                          >
                            {item.budgetLineItem} ➡ {item.accountName}
                          </option>
                        ))}
                  </select>
                  {/*END OF GL CATEGORY INPUT */}
                  {/* GL CATEGORY NAME */}
                  <p className="label2">
                    Account Code/Account Name
                    <span
                      style={errorChecker}
                      className="projectClassEmptyError"
                    >
                      *
                    </span>
                  </p>
                  <input
                    className="glNameClass"
                    name="glAccount"
                    id={index}
                    // list="accountName"
                    autoComplete="off"
                    placeholder="Select a budget line item"
                    value={
                      this.props.projectClass[index]["glCategory"]
                        ? `${this.props.projectClass[index]["glAccount"].slice(
                            0,
                            10
                          )}/ ${this.props.projectClass[index][
                            "glAccount"
                          ].slice(11)}`
                        : "Select budget line item..."
                    }
                    disabled
                  />
                  {/* PROJECT CLASS */}
                  <p
                    className="label2ProjectClass"
                    style={
                      data.glCategory === "AdvancesFromOtherCRIS"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    Project Class
                    <span
                      style={errorChecker}
                      className="projectClassEmptyError"
                    >
                      *
                    </span>
                  </p>
                  <input
                    className="glNameClassProjectClass"
                    style={
                      data.glCategory === "AdvancesFromOtherCRIS"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                    type="text"
                    name="projectClass"
                    id={index}
                    list="advancesList"
                    autoComplete="off"
                    placeholder="Required"
                    value={data.projectClass}
                    onChange={(event) =>
                      this.props.changed(event, index, "projectClass")
                    }
                  />
                  <datalist id="advancesList">
                    {this.props.advancesProjectClass.map((data) => (
                      <option value={data} />
                    ))}
                  </datalist>

                  {/* ITEM NUMBER AND QUANTITY */}
                  {this.props.requestType === "PO Item" ? (
                    <div className="quantityAndItemNumber">
                      <div className="inputContainer1">
                        <p className="label3">
                          Item No.:
                          <span
                            style={errorChecker}
                            className="projectClassEmptyError"
                          >
                            *
                          </span>
                        </p>
                        <input
                          className="input3"
                          type="text"
                          id={index}
                          name="itemCode"
                          list="itemNumberList"
                          placeholder="Required"
                          value={data.itemCode}
                          onChange={(event) =>
                            this.props.changed(event, index, "itemCode")
                          }
                        />
                      </div>
                      <div className="inputContainer2">
                        <p className="label4">
                          Quantity:
                          <span
                            style={errorChecker}
                            className="projectClassEmptyError"
                          >
                            *
                          </span>
                        </p>
                        <input
                          className="input4"
                          type="text"
                          id={index}
                          min="1"
                          name="quantity"
                          placeholder="Required"
                          autoComplete="off"
                          value={data.quantity}
                          onBlur={(e) =>
                            this.props.onBlurNumber(e, index, "quantity")
                          }
                          onChange={(event) =>
                            this.props.changed(event, index, "quantity")
                          }
                        />
                      </div>
                    </div>
                  ) : null}

                  {/* class DEPARTMENT INPUT*/}
                  <p className="label2">
                    Requesting Department:
                    <span id="particularsEmptyError" className="errorChecker">
                      *
                    </span>
                  </p>
                  <select
                    className="description1Class"
                    name="classDepartment"
                    id={index}
                    value={this.props.requestingDepartment}
                    onChange={this.props.handleChangeProjectClassValue}
                    disabled={index === 0 ? true : false}
                  >
                    {this.props.userDeptList
                      .filter((list) => list.isApproved === true)
                      .map((depts) => (
                        <option value={depts.centerName}>
                          {depts.centerName}
                        </option>
                      ))}
                  </select>
                  {/* END OF class DEPARTMENT INPUT */}

                  {/* DESCRIPTION 1 */}
                  <p className="label2">
                    Description 1
                    <span
                      style={errorChecker}
                      className="projectClassEmptyError"
                    >
                      *
                    </span>
                  </p>
                  <input
                    className="description1Class"
                    type="text"
                    name="description1"
                    id={index}
                    autoComplete="off"
                    placeholder="Required"
                    value={data.description1}
                    onChange={(event) =>
                      this.props.changed(event, index, "description1")
                    }
                  />

                  {/* DESCRIPTION  2*/}
                  <p className="label2">
                    Description 2
                    <span
                      style={errorChecker}
                      className="projectClassEmptyError"
                    ></span>
                  </p>
                  <input
                    className="description2Class"
                    type="text"
                    name="description2"
                    id={index}
                    autoComplete="off"
                    placeholder="Optional"
                    value={data.description2}
                    onChange={(event) =>
                      this.props.changed(event, index, "description2")
                    }
                  />

                  {/* Gross Price  */}
                  <p className="label2">
                    Gross Price:
                    <span
                      style={errorChecker}
                      className="projectClassEmptyError"
                    >
                      *
                    </span>
                  </p>
                  <input
                    className="description2Class"
                    min="0.01"
                    step="any"
                    type="number"
                    name="grossPricePerItem"
                    id={index}
                    value={this.props.projectClass[index].grossPricePerItem}
                    autoComplete="off"
                    placeholder="Required"
                    onBlur={(e) =>
                      this.props.onBlurNumber(e, index, "grossPricePerItem")
                    }
                    onChange={(event) =>
                      this.props.changed(event, index, "grossPricePerItem")
                    }
                  />

                  {/* VAT TYPE AND WITHHOLDING TAX */}
                  <div className="quantityAndItemNumber">
                    <div className="inputContainer1">
                      <p className="label3">
                        Vat Type.:
                        <span
                          style={errorChecker}
                          className="projectClassEmptyError"
                        >
                          *
                        </span>
                      </p>
                      {/* <input className="input5" type="text"/> */}
                      <select
                        className="input5"
                        id={index}
                        type="number"
                        name="vatType"
                        placeholder="Required"
                        value={
                          data.vatType === "X1" ? "None IVAT-X1" : data.vatType
                        }
                        onChange={(event) =>
                          this.props.changed(event, index, "vatType")
                        }
                      >
                        <option
                          className="vatTypeInitialValue"
                          value=""
                          selected
                          hidden
                        >
                          Please Choose...
                        </option>
                        {this.props.vatTypeSelections}
                      </select>
                    </div>
                    <div className="inputContainer2">
                      <p className="label3">
                        Withholding Tax:
                        <span
                          style={errorChecker}
                          className="projectClassEmptyError"
                        >
                          *
                        </span>
                      </p>
                      {/* <input className="input6" type="text"/>/ */}
                      <select
                        className="input6"
                        id={index}
                        type="text"
                        name="wTaxType"
                        value={this.props.projectClass[index].wTaxType}
                        onChange={(event) =>
                          this.props.changed(event, index, "wTaxType")
                        }
                      >
                        {this.props.wTaxRates.map(
                          ({ wTaxCode, wTaxDisplayName }) => {
                            return (
                              <option key={wTaxCode} value={wTaxCode}>
                                {wTaxCode === "X1"
                                  ? "None (X1)"
                                  : wTaxDisplayName + " " + wTaxCode}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="subComputationContainer">
                    <div className="subComputation1">
                      <p>Sub Total Gross Price</p>
                      <p>Sub Total Net Price</p>
                    </div>
                    <div className="subComputation2">
                      <div className="subComputations">
                        <span>
                          <h4 style={padding1}>&#8369;</h4>
                          <h4 className="subTotalGrossPrice">
                            {this.getSubtotalGrossPrice(index)}
                          </h4>
                        </span>
                        <span>
                          <h4 style={padding1}>&#8369;</h4>
                          <h4 className="subTotalNetPrice">
                            {this.getSubtotalNetPrice(index)}
                          </h4>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* COC EXPENSES LIST */}
                  <datalist id="cocExpenses">
                    {this.props.cocExpenses.map((data) => (
                      <option value={data} />
                    ))}
                  </datalist>
                  {/* ADVANCES LIST */}
                  <datalist id="advances">
                    {this.props.advances.map((data) => (
                      <option value={data} />
                    ))}
                  </datalist>
                  {/* PPE ACCOUNTS LIST */}
                  <datalist id="ppeAccounts">
                    {this.props.ppeAccounts.map((data) => (
                      <option value={data} />
                    ))}
                  </datalist>
                  {/* Admin Expenses */}
                  <datalist id="adminExpenses">
                    {this.props.adminExpenses.map((data) => (
                      <option value={data} />
                    ))}
                  </datalist>
                  <datalist id="itemNumberList">
                    {this.state.itemNoLists.map((data) => (
                      <option value={data} />
                    ))}
                  </datalist>
                  {/*END OF GL CATEGORY NAME */}
                </div>
              ))}
              {/* ======================================================================================================== */}
              {/*END OF PAGE 2 */}
            </div>
            <div id="totalComputation" className="totalComputation">
              <div className="computationDesc">
                <h4>Requesting Gross Price:</h4>
                <h4>Requesting Amount:</h4>
              </div>
              <div className="computations">
                <span>
                  <h4 style={padding1}>&#8369;</h4>
                  <h4 id="requestingGrossPrice">
                    {this.getRequestingGrossPrice(this.props.projectClass)}
                  </h4>
                </span>
                <span>
                  <h4 style={padding1}>&#8369;</h4>
                  <h4 id="requestingAmount">
                    {this.getRequestingAmountPrice()}
                  </h4>
                </span>
              </div>
              <div className="addProjectClassBtnContainer">
                <h5 onClick={this.props.addProjectClass}>Add Project Class</h5>
              </div>
            </div>

            <div className="formHintContainer" id="formHintContainer">
              <i
                id="validationHintIcon"
                class="fas fa-exclamation-triangle"
              ></i>
              <span>
                Error:
                <span id="draftErrorHint"></span>
              </span>
              <span id="errorHint"></span>
            </div>

            <div id="submitButtonDiv" className="submitButtonDiv">
              <button
                id="submitButton"
                type="submit"
                disabled={this.props.isLoading}
                style={this.props.isLoading ? { backgroundColor: "grey" } : {}}
              >
                Submit
              </button>
            </div>
          </form>

          <div id="nextButton" className="nextButton">
            <button type="button" onClick={this.handleShowPage2}>
              NEXT
            </button>
          </div>

          {/* <button onClick={this.props.checkStateValue}>Check State</button> */}
        </div>
      </>
    );
  }
}

const currentAttachPdf = {
  color: "white",
  fontFamily: "Calibri",
  fontSize: "15px",
  fontWeight: "bold",
  background: "#ee3124",
  marginTop: "10px",
  padding: "5px",
  cursor: "pointer",
};

const styleBtn = {
  background: "#2B2C2B",
  color: "white",
  cursor: "pointer",
};

const errorChecker = {
  color: "red",
  fontFamily: "Calibri",
  fontSize: "15px",
};
const padding1 = {
  paddingRight: "5px",
};

const displayNone = {
  display: "none",
};

export default DraftView;
